/**
 * 小po
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/9      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import { Button,Tooltip } from "antd";
import "./index.less";
import {
    numberWithCommas,
    toFixedWithCommas,
} from "../../../../utils/number-util";
import dayjs from "dayjs";
class SmallPo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            model: props.model,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            model: nextProps.model,
        });
    }

    render() {
        let { model } = this.state;
        return (
            <div className="small-po-wrap">
                <div>
                    {this.props.isHideTitle ? null : (
                        <p className="name">
                            {__getServerLanguage("ZiDingDan")} {model.code}
                            <span className="po-status-label">
                                {__getServerDictItem(
                                    "sale_po_ddp_status_buyer." + model.statusBuyer
                                ) || "-"}
                            </span>
                        </p>
                    )}
                    <p>
                        {
                            !this.props.bigPoModel.orderType?
                                <span className="tit">
                                    {model.preLoadDateOriginal &&dayjs(model.preLoadDateOriginal).format("YYYY-MM-DD") !== dayjs(model.preLoadDate).format("YYYY-MM-DD")
                                        ?
                                        __getServerLanguage("XinYuJiDaoGangShiJian")
                                        :
                                        __getServerLanguage("YuJiDaoGangShiJian")
                                    }
                                    ：
                                </span>
                                :
                                <span>
                                    {__getServerLanguage('YuJiFaHuoShiJian')}：
                                </span>
                        }

                        {model.preLoadDateOriginal &&dayjs(model.preLoadDateOriginal).format("YYYY-MM-DD") !== dayjs(model.preLoadDate).format("YYYY-MM-DD")
                            ?
                            <i>
                                {model.preLoadDate
                                    ? dayjs(model.preLoadDate).format(
                                        "YYYY-MM-DD"
                                    )
                                    : ""}
                            </i>
                            :
                            <span>
                                {model.preLoadDate
                                    ? dayjs(model.preLoadDate).format(
                                        "YYYY-MM-DD"
                                    )
                                    : ""}
                            </span>}
                        <span className="tit margin-left-20">
                            {__getServerLanguage("XiangShu")}：
                        </span>{" "}
                        <span className="color-black">
                            {model.totalQuantity || "-"}
                        </span>
                        <span className="tit margin-left-20">
                            {__getServerLanguage("KuanShu")}：
                        </span>{" "}
                        <span className="color-black">
                            {model.totalCount || "-"}
                        </span>
                        <span className="tit margin-left-20">
                            {__getServerLanguage("TiJi")}：
                        </span>{" "}
                        <span className="color-black">
                            {toFixedWithCommas(model.totalVolume, 3) || "-"} m³
                        </span>
                    </p>
                    <p>
                        {model.trackTime
                            ? dayjs(model.trackTime).format("YYYY-MM-DD HH:mm")
                            : "-"}
                        &nbsp;&nbsp;&nbsp;{model.trackDesc || "-"}
                    </p>
                    {(model.status != -10 &&!this.props.bigPoModel.orderType)? (
                        <div className="margin-top-16">
                            <span className="tip">
                                {__getServerLanguage("DingDan")}：
                            </span>
                            <span className="color-black">
                                {model.currencySymbol}{" "}
                                {numberWithCommas(
                                    toFixedWithCommas(
                                        model.discountBeforePrice,
                                        2
                                    )
                                )}
                            </span>
                            {model.discountPriceTotal ? (
                                <span>
                                    (
                                    <span className="tip">
                                        {__getServerLanguage("YouHui2")}
                                    </span>
                                    <span className="color-black">
                                        {model.currencySymbol}{" "}
                                        {numberWithCommas(
                                            toFixedWithCommas(
                                                model.discountPriceTotal,
                                                2
                                            )
                                        )}
                                    </span>
                                    )
                                </span>
                            ) : null}
                            <span className="tit margin-left-20">
                                {__getServerLanguage("DingJin")}：
                            </span>
                            <span className="color-black">
                                {model.currencySymbol}{" "}
                                {numberWithCommas(
                                    toFixedWithCommas(model.needDepositMoney, 2)
                                )}
                            </span>
                            {model.status !=10 &&
                            model.finalPaymentMoney !== 0 ? (
                                <span>
                                    <span className="tit margin-left-20">
                                        {__getServerLanguage("WeiKuan")}：
                                    </span>
                                    <span className="color-black">
                                        {model.currencySymbol}{" "}
                                        {numberWithCommas(
                                            toFixedWithCommas(
                                                model.finalPaymentMoney,
                                                2
                                            )
                                        )}
                                    </span>
                                </span>
                            ) : null}
                            {
                                model.cancelRefundTotal?
                                    <span className="color-danger margin-left-20">{__getServerLanguage('TuiKuan')}：</span>:
                                    null
                            }
                            {
                                model.cancelRefundTotal?
                                    <span className="color-danger">{model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.cancelRefundTotal,2))}</span>
                                    :
                                    null
                            }
                        </div>
                    ) : null}

                    {
                        (model.status!=-10&&this.props.bigPoModel.orderType)?
                            <div className="margin-top-16">
                                <span className="tip">{__getServerLanguage('DingDan')}：</span>
                                <span className="color-black">{model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.discountBeforePrice,2))}</span>
                                {
                                    model.discountPriceTotal?
                                        <span>
                                            (<span className="tip">{__getServerLanguage('YouHui2')}</span>
                                            <span className="color-black">{model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.discountPriceTotal,2))}</span>)
                                        </span>
                                        :
                                        null
                                }
                                {
                                    model.cancelRefundTotal?
                                        <span className="color-danger margin-left-20">{__getServerLanguage('TuiKuan')}：</span>:
                                        null
                                }
                                {
                                    model.cancelRefundTotal?
                                        <span className="color-danger">{model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.cancelRefundTotal,2))}</span>
                                        :
                                        null
                                }
                            </div>:
                            null

                    }
                    {
                        (model.statusBuyer!=-10&&model.arriveLate)?
                            <div className="claim-demage-tip">
                                <Tooltip placement="topLeft" title={__getServerLanguage('DingDanWanDaoShiJianChaoGhuNian')} arrow>
                                    <i className="iconfont icon-xinxix margin-right-5"></i>
                                </Tooltip>
                                {/*很抱歉！您的订单比预期晚到了<span className="color-danger">{model.arriveLateDay}</span>天，您可获得赔偿 <span className="color-danger"> {model.currencySymbol} {model.arriveLatePayAmount}</span>元。*/}
                                <span className="margin-right-10" dangerouslySetInnerHTML={{ __html: __getServerLanguage('HenBaoQianNinDeDingDanBiYuQi',`<span class="color-danger">${model.arriveLateDay}</span>`,`<span class="color-danger"> ${model.currencySymbol} ${toFixedWithCommas(model.arriveLatePayAmount,2)}</span>`) }}></span>

                            </div>
                            :
                            null
                    }
                </div>
                <Button
                    disabled={this.props.status === -1 ? true : false}
                    shape="round"
                    href={`/order/sale/detail?id=${model.id}`}
                    target="_blank"
                    size="small"
                >
                    {__getServerLanguage("XiangQing")}
                </Button>
            </div>
        );
    }
}

SmallPo.defaultProps = {
    //数据源
    model: {},
    //大po
    bigPoModel:{},
    //大po状态
    status: null,
    //如果没有拆单，隐藏标题
    isHideTitle: false,
};

SmallPo.propTypes = {
    model: PropTypes.object,
    bigPoModel:PropTypes.object,
    status: PropTypes.number,
    isHideTitle: PropTypes.bool,
};
export default SmallPo;
